<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card class="ins-card">
      <v-toolbar flat class="ins-hero">
        <div>
          <div class="text-h6 white--text">Pre-inscripción de estudiante</div>
          <div class="text-body-2 white--text">
            Confirma los datos para registrar la pre-inscripción
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-chip color="yellow darken-2" class="deep-orange--text text--darken-4" small>
          Pre-inscripción
        </v-chip>
      </v-toolbar>

      <v-card-text class="pt-4">
        <v-row dense>
          <v-col cols="12">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2">Resumen</div>
              <div class="text-body-2 text--secondary">
                <b>Programa:</b>
                <span v-if="loading_programa">cargando...</span>
                <span v-else>{{ programa.codigo }} {{ programa.nombre_compuesto }}</span>
              </div>
              <div class="text-body-2 text--secondary">
                <b>Estudiante:</b> {{ row.persona_name }}
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="cerrar()">Cerrar</v-btn>
        <v-btn
          color="green"
          class="white--text"
          :loading="loading"
          @click="realizar_ins()"
        >
          <v-icon left small>mdi-check-circle</v-icon>
          Proceder a Pre-inscribir
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<style scoped>
  .ins-card {
    border-radius: 16px;
    overflow: hidden;
  }
  .ins-hero {
    min-height: 90px;
    background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%);
  }
</style>

<script>
  import { getprograma, realizar_preinscripcion } from './utils';
  import { update_prospecto_estado } from '../utils';

  export default {
    components: {},
    data() {
      return {
        dialog: false,
        loading: false,
        loading_programa: false,
        programa: {},
        row: {},
      };
    },
    methods: {
      async openmodal(row) {
        this.row = row;
        this.programa = {};
        this.dialog = true;
        this.loading_programa = true;
        const res = await getprograma(row.programa_id);
        this.loading_programa = false;
        this.programa = res;
      },
      cerrar() {
        this.dialog = false;
      },
      async saveEstadoProspecto(estado){
        const dt = {
          prospecto_id: this.row.id,
          estado: estado
        }
        await update_prospecto_estado(dt)
      },
      async realizar_ins(){ 

        const inscrip = {
            asesor_id: parseInt(this.row.asesor_id),
            canal_id: null,
            estudiante_id: parseInt(this.row.persona_id),
            programa_id: parseInt(this.row.programa_id),
            registrado_por: this.$store.state.DATA_USER.id,
        }

        this.loading = true;
        const res = await realizar_preinscripcion(inscrip)
        window.console.log('ressss', res);

        if(res && res.enrollment_id){
            this.$root.$notify.show(`pre-inscrito correctamente ID: ${res.enrollment_id}`, { color: 'purple', x: 'right' });
            await this.saveEstadoProspecto('PREINSCRITO')
            this.loading = false;
            this.cerrar();
            this.$emit('done');
        }else if(res && res.error){
          if(res.error == 'Error, el estudiante se encuentra en un estado inscrito.'){
            await this.saveEstadoProspecto('INSCRITO')
          }else if(res.error == 'Error, el estudiante se encuentra en un estado preinscrito.'){
            await this.saveEstadoProspecto('PREINSCRITO')
          }
          this.$root.$notify.show(res.error, { color: 'red', x: 'right' });
        }else{
          this.$root.$notify.show('Algo salio mal :(', { color: 'red', x: 'right' });
        }
        this.loading = false;
      }
    },
  };
</script>
